import BaseCommunicator from "./BaseCommunicator"

class BrowserCommunicator extends BaseCommunicator {
    async getDeviceType() {
        return (await this.getConfig()).httpHeaders["Device-Type"];
    }

    async getConfig() {
        return new Promise(resolve => {
            setTimeout(() => {
                resolve({
                    httpHeaders: {
                        "Device-Type": "Android"
                    }
                });
            }, 50);
        });
    }

    disableFairtiqModal() {
        console.log("Disable fairtiq model");
    }

    openDeeplink(deeplink, url) {
        console.log("open deeplink", deeplink, "or", url);
    }

    trackPageImpression(pageName) {
        console.log("Track page impression", pageName);
        return null;
    }

    trackEvent(action, category, label) {
        console.log("Track event", action, category, label);
        return null;
    }
}

export default BrowserCommunicator;
